module.exports = __webpack_public_path__ + "static/img/pitch.1ef4f05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/flightDetail_eyes/pitch.png
// module id = fpV3
// module chunks = 2